export default {"src":"https://s.sylndr.com/c-350916f/_next/static/media/line.493934d3.svg","height":11,"width":281,"blurWidth":0,"blurHeight":0};